import React from 'react';
import PropTypes from 'prop-types';
import { Add as AddIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import TagChip from '../../../atoms/TagChip';

const getTagKey = (tag) => (typeof tag === 'object' ? tag._id : tag);
const getTagLabel = (tag) => (typeof tag === 'object' ? tag.name : tag);

const ArticleModalTagsSection = ({
  article,
  fontSize,
  mt,
  onAddTag,
  onRemoveTag,
  readOnly
}) => (
  <Box sx={{ mt }}>
    <Typography variant="h6" color="primary" gutterBottom sx={{ fontSize: '1.1rem', fontWeight: 600 }}>
      Tags
    </Typography>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
      {article.tags && article.tags.length > 0 && article.tags.map((tag) => (
        <TagChip
          key={getTagKey(tag)}
          label={getTagLabel(tag)}
          variant="outlined"
          onDelete={onRemoveTag ? () => onRemoveTag(tag) : undefined}
          fontSize={fontSize}
          size="medium"
        />
      ))}
      <TagChip
        icon={<AddIcon />}
        label="Adicionar Tag"
        onClick={onAddTag}
        color="primary"
        variant="outlined"
        fontSize={fontSize}
        size="medium"
        sx={{ display: readOnly ? 'none' : undefined }}
      />
    </Box>
  </Box>
);

ArticleModalTagsSection.propTypes = {
  article: PropTypes.shape({
    tags: PropTypes.array
  }).isRequired,
  fontSize: PropTypes.string,
  mt: PropTypes.number,
  onAddTag: PropTypes.func.isRequired,
  onRemoveTag: PropTypes.func,
  readOnly: PropTypes.bool
};

ArticleModalTagsSection.defaultProps = {
  fontSize: undefined,
  mt: 3,
  onRemoveTag: null,
  readOnly: false
};

export default ArticleModalTagsSection;
